import { useEffect, useState } from "react";
import { MapView, type ParcelClick } from "./MapView";
import { Search } from "./Search";
import { Legend } from "./Legend";
import { BottomSheet } from "./BottomSheet";
import { RankedList } from "./RankedList";
import { MondayEmail } from "./MondayEmail";

export default function App() {
  const [click, setClick] = useState<ParcelClick | null>(null);
  const [listOpen, setListOpen] = useState(false);
  const [route, setRoute] = useState<string>(window.location.pathname);

  useEffect(() => {
    const onPop = () => setRoute(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  if (route === "/digest" || route === "/digest/") return <MondayEmail />;

  const pickFromFolio = (f: string) => setClick({ folio: f, props: {} });

  return (
    <div className="ps-app">
      <MapView onSelect={setClick} />
      <div className="ps-overlay ps-overlay--top">
        <div className="ps-brand">ParcelSignal</div>
        <Search onPick={pickFromFolio} />
        <button className="ps-btn-top" onClick={() => setListOpen(true)} aria-label="Top opportunities">
          Top 50
        </button>
      </div>
      <div className="ps-overlay ps-overlay--bl">
        <Legend />
      </div>
      <BottomSheet click={click} onClose={() => setClick(null)} />
      <RankedList open={listOpen} onClose={() => setListOpen(false)} onPick={(f) => { setListOpen(false); pickFromFolio(f); }} />
    </div>
  );
}
